import * as React from 'react';
import { connect } from 'react-redux';
import injectSheet from 'react-jss';
import { DatePicker, Select, Button, Input, Checkbox, message, Radio, Spin } from 'antd';
import { getPorts } from 'src/api/containerTracking';
import { withRouter } from 'react-router';
import SearchTagsInput from 'src/components/common/SearchTagsInput';
import { getAllInquiriesSetFilter } from 'src/actions/inquiryShipperActions';
import { bindActionCreators } from 'redux';
import { searchCountry } from 'src/api/country';
import { getInternalReferenceNumberList, getInquiryCreators, getInquiryCreatorOrgs } from 'src/api/inquiry';
import { fetchAllTeams } from 'src/api/teams';
import { fetchAllStakeholdersPaginated } from 'src/api/masters';
import { defaultAccessKeys, getPolPodTypesInquiryFilter, visibleAccessTypeLabel } from '../InquiryUtils';
import uniqBy from 'lodash/uniqBy';
import { fetchAllUsersOfCurrentOrg } from 'src/api/users';
import { fetchAddresses } from 'src/api/organisationProfiling';
import { UserRole, StakeholderTypes } from 'src/Library/Constants';
import { Address, StakeholderFilterParams } from 'src/Library/Types';

interface User {
  id: string;
  email: string;
}

const Option = Select.Option;
const styles = (theme) => ({
  mainDiv: {
    background: 'white',
    position: 'absolute',
    zIndex: 10,
    marginTop: '-11px',
    width: '100%',
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #D9D9D9',
    boxShadow: '2px 2px 2px 0 rgba(0, 0, 0, 0.08)',
    '& .ant-calendar-picker-input': {
      padding: 0,
    },
  },
  childDiv: {
    alignItems: 'center',
    display: 'flex',
    marginBottom: 16,

    '& .ant-checkbox-group-item': {
      minWidth: 80,
    },
  },
  leftElement: {
    width: '170px',
    marginRight: '16px',
  },
  selectStyle: {
    minWidth: '200px',
  },
});
class InquiryShipperFilterPopup extends React.PureComponent<any, any> {
  state = {
    podDropdown: [],
    plantIds: [],
    isSearching: true,
    polDropdown: [],
    createData: {
      originPortIds: [],
      originPortNames: [],
    },
    sourceShippers: [],
    internalReferenceNumber: [],
    accessType: [],
    users: [],
    creationOrgs: [],
    uniqueOriginCities: [] as {key: string, label: string}[],
    uniqueDestinationCities: [] as {key: string, label: string}[],
    isLoadingUsers: false,
    isLoadingCreationOrgs: false,
    shipperList: [],
    customerList: [],
    supplierList: [],
    isStakeholderSearching: false,
  };

  componentDidMount() {
    this.searchInquiryAccess();
    this.fetchConsignerAddress();
    const { userData, isParentOrg } = this.props;
    if (userData) {
      const IsAdmin=userData?.role ===UserRole.ADMIN ? true : false
      this.getListUsers(userData.id ,IsAdmin );
      if (isParentOrg) this.getInquiryCreatorOrgs();
    }
  }

  componentDidUpdate(prevProps) {
    const { userData, isParentOrg } = this.props;
    // Only call if userData.id has changed
    if (userData?.id && userData.id !== prevProps.userData?.id) {
      const IsAdmin=userData?.role ===UserRole.ADMIN ? true : false
      this.getListUsers(userData?.id , IsAdmin);
      if (isParentOrg) this.getInquiryCreatorOrgs();
    }
  }

  searchForSourcePort = async (queryString: string, portType: string) => {
    const response = await getPorts({
      queryString,
      type: 'ALL',
    });
    if (response.isSuccess) {
      this.setState({
        [portType]: response.data.map((el) => ({
          key: el.code,
          label: el.name.concat('[', `${el.code}`, ']'),
        })),
      });
    } else {
      this.setState({
        [portType]: [],
      });
    }
  };

  searchInternalReferenceNumber = async (inquiryString: string) => {
    const response = await getInternalReferenceNumberList({ inquiryString, type: 'SHIPPER' });
    if (response.isSuccess) {
      this.setState({
        internalReferenceNumber: response.data.map((item) => ({
          key: item.internalReferenceNumber,
          label: item.internalReferenceNumber,
        })),
      });
    }
  };

  searchInquiryAccess = async () => {
    const { visibleAccessTypes, userData } = this.props;
    let visibleTypes = visibleAccessTypes;
    if (!this.props.visibleAccessTypes.length) visibleTypes = defaultAccessKeys;
  
    const constant = visibleTypes.map((key) => ({
      key,
      label: visibleAccessTypeLabel[key],
    }));
    const visibleAccessFilters = constant.filter((data) => data.key !== 'TEAM');
    const response = await fetchAllTeams({adminTeamRestriction: true});
    
    // Remove all the user-related logic from this method
    // since we're handling users separately in getListUsers
    
    if (response.isSuccess) {
      if (visibleTypes.includes('TEAM')) {
        const data = response.data.map((item) => {
          return ({
            key: item.id,
            label: `${item.name} (${item.reference_number})`,
          })
        });
        const newData = visibleAccessFilters.concat(data);
        this.setState({
          accessType: newData,
        });
        return;
      }
    }
    
    this.setState({
      accessType: visibleAccessFilters,
    });
  };

  searchForSourceCountry = async (queryString: string, portType: string) => {
    const response = await searchCountry({ queryString });
    if (response.isSuccess) {
      this.setState({
        [portType]: response.data.map((country) => ({
          key: country.countryCode,
          label: country.countryName,
        })),
      });
    } else {
      this.setState({
        [portType]: [],
      });
    }
  };

  fetchConsignerAddress = async (queryString?: string) => {
    const response = await fetchAddresses(queryString ? { queryString, searchForCity: true } : { limit: 50 });
    if (response.isSuccess) {
      const addressesList: Address[] = response.data || [];
      const originCities = {};
      const destinationCities = {};
      addressesList.forEach((address) => {
        if (address.city) {
          if (address.addressTypes?.includes('STUFFING')) {
            originCities[address.city] = {key: address.city, label: `${address.city} [${address.countryCode || '-'}]`};
          } 
          if (address.addressTypes?.includes('DESTUFFING')) {
            destinationCities[address.city] = {key: address.city, label: `${address.city} [${address.countryCode || '-'}]`};
          }
        }
      });
      this.setState({
        uniqueOriginCities : Object.values(originCities),
        uniqueDestinationCities: Object.values(destinationCities)
      });
    }
  }

  searchConsignerAddress = async (queryString: string, stateKey: string) => {
    if (stateKey === 'polDropdown') {
      if (queryString) {
        await this.fetchConsignerAddress(queryString);
        this.setState({
          [stateKey]: this.state.uniqueOriginCities.filter(city => 
          city?.label.toLowerCase().includes(queryString?.toLowerCase())),
        });
      } else {
        await this.fetchConsignerAddress();
        this.setState({
          [stateKey]: this.state.uniqueOriginCities,
        });
      }
    } else if (stateKey === 'podDropdown') {
      if (queryString) {
        await this.fetchConsignerAddress(queryString);
        this.setState({
          [stateKey]: this.state.uniqueDestinationCities.filter(city => 
          city?.label.toLowerCase().includes(queryString?.toLowerCase())),
        });
      } else {
        await this.fetchConsignerAddress();
        this.setState({
          [stateKey]: this.state.uniqueDestinationCities,
        });
      }
    }
  }

  handleSearch = (type: string, query: string, portType: string) => {
    if (type === 'port') {
      this.searchForSourcePort(query, portType);
    } else if (type === 'city') {
      this.searchConsignerAddress(query, portType);
    } else {
      this.searchForSourceCountry(query, portType);
    }
  };

  handleApply = () => {
    const { inquiriesCreatedBy, userIdList } = this.props.filters
    if (inquiriesCreatedBy === 'others' && (!userIdList?.length)) {
      message.error('Atleast one user in required');
      return;
    }
    this.props.handleApply()
  }

  handleOriginDestinationSetFilter = (searchFilterTypeValue, value, filterType: 'pol' | 'pod') => {
    if (filterType === 'pol') {
      this.props.getAllInquiriesSetFilter({
        polList: searchFilterTypeValue === 'port' ? value : [],
        originCityList: searchFilterTypeValue === 'city' ? value : [],
        originCountryList: searchFilterTypeValue === 'country' ? value : [],
      });
    } else {
      this.props.getAllInquiriesSetFilter({
        podList: searchFilterTypeValue === 'port' ? value : [],
        destinationCityList: searchFilterTypeValue === 'city' ? value : [],
        destinationCountryList: searchFilterTypeValue === 'country' ? value : [],
      });
    
    }
  }

  getListUsers = async (userId: string, isAdmin: boolean) => {
    // Prevent duplicate calls while one is in progress
    if (this.state.isLoadingUsers) return;
    
    this.setState({ isLoadingUsers: true });
    
    try {
      const response = await getInquiryCreators({ 
        userId, 
        ...(isAdmin && { allFlag: isAdmin }) 
      });
      if (response.isSuccess) {
        const users = response.data?.map((user) => ({
          key: user.id,
          label: user.name || user.id,  // Added fallback for null names
        }));
        this.setState({ users, isLoadingUsers: false });
      } else {
        this.setState({ users: [], isLoadingUsers: false });
      }
    } catch (error) {
      this.setState({ users: [], isLoadingUsers: false });
    }
  }

  getInquiryCreatorOrgs = async (queryString?: string) => {
    if (this.state.isLoadingCreationOrgs) return;

    this.setState({ isLoadingCreationOrgs: true });

    try {
      const response = await getInquiryCreatorOrgs( queryString ? { queryString } : undefined);
      if (response.isSuccess) {
        const orgs = response.data?.map((org) => ({
          key: org.organisationId,
          label: org.organisationName || org.organisationId,
        }));
        this.setState({ creationOrgs: orgs, isLoadingCreationOrgs: false });
      } else {
        this.setState({ creationOrgs: [], isLoadingCreationOrgs: false });
      }
    } catch (error) {
      this.setState({ creationOrgs: [], isLoadingCreationOrgs: false });
    }
  }

  timeout: NodeJS.Timeout | null = null;

  searchStakeholders = async (
    stakeholderType: StakeholderTypes.SHIPPER | StakeholderTypes.CUSTOMER | StakeholderTypes.SUPPLIER,
    queryString?: string
  ) => {
    this.setState({ isStakeholderSearching: true });
    
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    
    this.timeout = setTimeout(async () => {
      try {
        const response = await fetchAllStakeholdersPaginated({
          stakeholderType: [stakeholderType],
          searchQuery: queryString,
          resultPerPage: 25,
          currentPageNumber: 1
        });

        if (response.isSuccess) {
          const stakeholderData = response.data?.data;
          const mappedData = stakeholderData?.map((item) => ({
            key: item.org2Id,
            label: item.name,
          })) || [];
          
          // Set appropriate list based on stakeholder type
          if (stakeholderType === StakeholderTypes.SHIPPER) {
            this.setState({ shipperList: mappedData });
          } else if (stakeholderType === StakeholderTypes.CUSTOMER) {
            this.setState({ customerList: mappedData });
          } else if (stakeholderType === StakeholderTypes.SUPPLIER) {
            this.setState({ supplierList: mappedData });
          }
        }
      } catch (e) {
        message.error(e);
      } finally {
        this.setState({ isStakeholderSearching: false });
      }
    }, 200);
  }

  renderOriginDestinationFilter = (filterType: 'pol' | 'pod') => {
    const { podDropdown, polDropdown} = this.state;
    
    const {
      originCountryList,
      destinationCountryList,
      polList,
      podList,
      podSearch,
      polSearch,
      originCityList,
      destinationCityList,
    } = this.props.filters;
    
    let polValue = polList;
    let podValue = podList;
    
    if (polSearch === 'city') { 
      polValue = originCityList
    } else if (polSearch === 'country') {
      polValue = originCountryList
    }
    
    if (podSearch === 'city') { 
      podValue = destinationCityList
    } else if (podSearch === 'country') {
      podValue = destinationCountryList
    }
    let dropdownType = filterType === 'pol' ? 'polDropdown' : 'podDropdown';
    let searchFilterKey = filterType === 'pol' ? 'polSearch' : 'podSearch';
    let searchFilterInputValue = filterType === 'pol' ? polValue : podValue;
    let searchFilterTypeValue = filterType === 'pol' ? polSearch : podSearch;
    let dropdownOptions = filterType === 'pol' ? polDropdown : podDropdown;

    return (
      <Input.Group compact style={{ minWidth: '31%', maxWidth: '60%' }}>
        <Select
          value={searchFilterTypeValue}
          style={{ width: '15%' }}
          onChange={(type) => this.props.getAllInquiriesSetFilter({ [searchFilterKey]: type })}
        >
          {getPolPodTypesInquiryFilter.map(({ key, label }) => (
            <Option value={key} key={key} data-testid={`${filterType}${label}`}>
              {label}
            </Option>
          ))}
        </Select>
        <SearchTagsInput
          mode="multiple"
          placeholder={`Search and select a ${searchFilterTypeValue}`}
          style={{ minWidth: '35%' }}
          options={dropdownOptions}
          value={searchFilterInputValue}
          onChange={(value) => this.handleOriginDestinationSetFilter(searchFilterTypeValue, value, filterType)}
          searchFunction={(e) => this.handleSearch(searchFilterTypeValue, e, dropdownType)}
          size={'default'}
        />
      </Input.Group>
    );
  }

    renderCreationOrganisationFilter = () => {
    const { creationOrgs, isLoadingCreationOrgs } = this.state;
    const { filters, classes } = this.props;
    return (
      <div className={classes.childDiv}>
            <span className={classes.leftElement}>Shipper</span>
            <SearchTagsInput
              mode="multiple"
              placeholder="Select shipper organisation"
              style={{ minWidth: '40%', maxWidth: '60%' }}
              options={creationOrgs}
              loading={isLoadingCreationOrgs}
              value={
                filters.shipperIdList && filters.shipperIdList.map((key) => ({ key }))
              }
              onChange={(org = []) => {
                this.props.getAllInquiriesSetFilter({
                  shipperIdList: org.map(({ key }) => key),
                });
              }}
              searchFunction={(queryString) => this.getInquiryCreatorOrgs(queryString)}
              size={'default'}
            />
          </div>
    )
  }

  renderStakeholderFilter = (stakeholderFilterParams: StakeholderFilterParams) => {
    const { classes, filters, getAllInquiriesSetFilter } = this.props;
    const { isStakeholderSearching } = this.state;
    const { stakeholderType, filterLabel, placeholder, options, filterKey } = stakeholderFilterParams;
    return (
      <div className={classes.childDiv}>
        <span className={classes.leftElement}>{filterLabel}</span>
        <SearchTagsInput
          mode="multiple"
          placeholder= {placeholder}
          style={{ minWidth: '30%', maxWidth: '60%' }}
          options={options}
          loading={isStakeholderSearching}
          value={filters[filterKey]}
          onChange={(values = []) => {
            getAllInquiriesSetFilter({
              [filterKey]: values,
            });
          }}
          searchFunction={(queryString) =>
            this.searchStakeholders(stakeholderType, queryString)
          }
          size={'default'}
        />
      </div>
    );
  }

  render() {
    const { classes, filters, getAllInquiriesSetFilter, userData, draftMandatoryFields, isParentOrg, inquiryFormPrefill } = this.props;
    const options = [
      { label: 'Import', value: 'IMPORT' },
      { label: 'Export', value: 'EXPORT' },
      { label: 'TRADE', value: 'TRADE' },
    ];
    
    const { internalReferenceNumber, accessType, shipperList, customerList, supplierList } = this.state;
    
    const { inquiriesCreatedBy } = filters;

    const shipperFilterParams: StakeholderFilterParams = {
      stakeholderType: StakeholderTypes.SHIPPER,
      filterLabel: 'Shipper',
      placeholder: 'Select Shipper',
      options: shipperList,
      filterKey: 'shipperIds',
    }

    const customerFilterParams: StakeholderFilterParams = {
      stakeholderType: StakeholderTypes.CUSTOMER,
      filterLabel: 'Customer',
      placeholder: 'Select Customer',
      options: customerList,
      filterKey: 'customerIds',
    }

    const supplierFilterParams: StakeholderFilterParams = {
      stakeholderType: StakeholderTypes.SUPPLIER,
      filterLabel: 'Supplier',
      placeholder: 'Select Supplier',
      options: supplierList,
      filterKey: 'supplierIds',
    }

    return (
      <div className={classes.mainDiv} data-testid={'inquiry-shipper-filters'}>
        <div>
          <div className={classes.childDiv}>
            <span className={classes.leftElement}>Origin</span>
            {this.renderOriginDestinationFilter('pol')}
          </div>

          <div className={classes.childDiv}>
            <span className={classes.leftElement}>Destination</span>
            {this.renderOriginDestinationFilter('pod')}
          </div>
           {/* Stakeholder Filters (Feature Flag Enabled) */}
           {inquiryFormPrefill && (
            <>
              {this.renderStakeholderFilter(shipperFilterParams)}
              {this.renderStakeholderFilter(customerFilterParams)}
              {this.renderStakeholderFilter(supplierFilterParams)}
            </>
          )}
          <div className={classes.childDiv}>
            <span className={classes.leftElement}>Internal Reference #</span>
            <SearchTagsInput
              mode="multiple"
              placeholder="Internal Reference #"
              style={{ minWidth: '30%', maxWidth: '60%' }}
              options={internalReferenceNumber}
              value={filters.internalReferenceNumberList}
              onChange={(internalList) => {
                getAllInquiriesSetFilter({
                  internalReferenceNumberList: internalList,
                });
              }}
              searchFunction={(e) => this.searchInternalReferenceNumber(e)}
              size={'default'}
            />
          </div>
          <div className={classes.childDiv}>
            <span className={classes.leftElement}>Inquiry Access</span>
            <SearchTagsInput
              mode="multiple"
              placeholder="Inquiry Access"
              style={{ minWidth: '30%', maxWidth: '60%' }}
              options={accessType}
              value={
                filters.accessTypeFilters &&
                filters.accessTypeFilters.map((item) => {
                  return item.accessType !== 'PUBLIC' && item.accessType !== 'PRIVATE'
                    ? {
                        key: item.teamId,
                        label: item.teamName,
                      }
                    : {
                        key: item.accessType,
                        label: item.teamName,
                      };
                })
              }
              onChange={(access) => {
                getAllInquiriesSetFilter({
                  accessTypeFilters: access.map((item) => {
                    return item.key !== 'PUBLIC' && item.key !== 'PRIVATE'
                      ? {
                          accessType: 'TEAM',
                          teamId: item.key,
                          teamName: item.label,
                        }
                      : {
                          accessType: item.key,
                          teamName: item.label,
                        };
                  }),
                });
              }}
              searchFunction={() => this.searchInquiryAccess()}
              size={'default'}
            />
          </div>
          <div className={classes.childDiv}>
            <span className={classes.leftElement}>Inquiry Created By</span>
            <SearchTagsInput
              mode="multiple"
              placeholder="Created by"
              style={{ minWidth: '30%', maxWidth: '60%' }}
              options={this.state.users}
              value={
                filters.userIdList &&
                filters.userIdList.map((key) => ({ key }))
              }
              onChange={(access) => {
                getAllInquiriesSetFilter({
                  userIdList: access.map(({ key }) => key),
                });
              }}
              searchFunction={() => this.searchInquiryAccess()}
              size={'default'}
            />
          </div>
          
         
          
          {isParentOrg && this.renderCreationOrganisationFilter()}
          <div className={classes.childDiv}>
            <span className={classes.leftElement}>Type</span>
            <Checkbox.Group
              options={options}
              value={filters.typeList}
              onChange={(checkedValues) => {
                this.props.getAllInquiriesSetFilter({
                  typeList: checkedValues,
                });
              }}
            />
          </div>
          {draftMandatoryFields && <>
            <div className={classes.childDiv}>
              <span className={classes.leftElement}>Draft Inquiries</span>
              <Radio.Group
                value={filters.isDraft}
                onChange={(ele) => {
                  this.props.getAllInquiriesSetFilter({
                    isDraft: ele?.target?.value,
                  });
                }}
              > 
                <Radio value={true}>Yes</Radio>
                <Radio value={false}>No</Radio>
              </Radio.Group>
            </div>
            <div className={classes.childDiv}>
              <span className={classes.leftElement}>Incomplete Draft</span>
              <Radio.Group
                value={filters.isDraftIncomplete}
                onChange={(ele) => {
                  this.props.getAllInquiriesSetFilter({
                    isDraftIncomplete: ele?.target?.value,
                  });
                }}
              > 
                <Radio value={true}>Yes</Radio>
                <Radio value={false}>No</Radio>
              </Radio.Group>
            </div>
          </>
          }
        </div>
        <div style={{ display: 'flex', marginLeft: '174px' }}>
          <Button
            disabled={this.props.loading}
            style={{
              width: 120,
              margin: '10px',
              backgroundColor: '#2A9FD8',
              border: '1px solid #2A9FD8',
            }}
            onClick={this.handleApply}
            type="primary"
          >
            Apply
          </Button>
          <Button style={{ width: 120, margin: '10px' }} onClick={() => this.props.handleCancel()}>
            Cancel
          </Button>
        </div>
      </div>
    );
  }
}

const InquiryShipperFilterPopupStyled = injectSheet(styles)(InquiryShipperFilterPopup);

const mapStateToProps = ({ inquiryShipperReducer, masterData }, ownProps) => ({
  filters: inquiryShipperReducer.selectedFilters,
  appliedFilters: inquiryShipperReducer.appliedFilters,
  visibleAccessTypes: masterData?.visibleAccessTypes?.INQUIRY ?? [],
  userData: masterData?.userData,
  isParentOrg: masterData?.isParentOrg,
  draftMandatoryFields: masterData?.mandatoryFieldsInInquiryDraft,
  inquiryFormPrefill: masterData?.modules?.inquiry_form_prefill,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAllInquiriesSetFilter,
    },
    dispatch
  );
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(InquiryShipperFilterPopupStyled)
);
